/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-04-06T16:13:17-07:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-13T09:02:16-07:00
 */

import React, { Component } from 'react';
import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';
import ResultList from '../../blocks/ResultList';
import BlankSlate from '../../blocks/BlankSlate';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import TextLink from '../../common/TextLink';
import ActivityItem from './ActivityItem';
import isEmpty from 'lodash/isEmpty';
import { borders } from '../../../style';

const listFeed = (items, feedType) => {

  if(isEmpty(items)) {
    return (<BlankSlate bordered={true} title="No activity yet." size='SM'/>);

  } else {
    const activityList = Object.keys(items).map((key) => {
      let acct, profile, linkTo, activityDt;
      if(feedType === 'msg') {
        activityDt = items[key].last_message.data.created_at.date;
        profile = items[key].other_profile.data;
        acct = profile.account.data;
        linkTo = '/messages/';
      } else {
        activityDt = items[key].created_at.date;
        acct = items[key].other_account.data;
        profile = acct.profile.data;
        linkTo = '/~';
      } 
      
      return (
        <ActivityItem
          linkTo={linkTo}
          key={key}
          acct={acct}
          activityDt={activityDt}
          profile={profile}
          feedType={feedType}
        />
      )
    });
    
    return (
      <ResultList>
        {activityList}
      </ResultList>
    )
  }
}

class ActivityFeed extends Component {

  render() {
    const {
      feed,
      moreLink,
      moreMsg,
      title,
      feedType
    } = this.props;

    return (
      <div>
        <Header>
          <Headline>{title}</Headline>
          <TextLink to={moreLink}>{moreMsg}</TextLink>
        </Header>
        <ReactPlaceholder
          type='media'
          ready={!feed.isFetching}
          rows={3}
          showLoadingAnimation
          style={{backgroundColor: 'white', border: borders.DEFAULT, padding: '10px'}}
        >
          {listFeed(feed.items, feedType)}
        </ReactPlaceholder>
      </div>
    );
  }
}

export default ActivityFeed;



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/ActivityFeed.jsx